// Omnix/common/schemas/collections/omniContacts.js
import { z } from "zod";

// Defines a single communication channel for a contact
const ChannelSchema = z.object({
    channelId: z.string().uuid().describe("Unique ID for this channel entry."),
    type: z.enum(["email", "voice","sms", "whatsapp", "voice", "web_chat", "facebook_messenger", "instagram", "telegram"])
        .describe("The type of communication channel."),
    value: z.string().min(1, "Channel value (e.g., email address or phone number) is required.")
        .describe("The identifier for the channel (e.g., user@example.com, +15551234567)."),
    label: z.string().optional().nullable().describe("A user-defined label (e.g., 'Work', 'Mobile')."),
    isPreferred: z.boolean().default(false).describe("Indicates if this is the preferred channel for outbound communication.")
});

// Defines the main contact record
const OmniContactSchema = z.object({
    _id: z.string().optional().describe("MongoDB ObjectId"),
    subscriptionId: z.string().describe("The subscription this contact belongs to."),
    
    // Core Identity
    firstName: z.string().optional().nullable(),
    lastName: z.string().optional().nullable(),
    email: z.string().email().optional().nullable(),
    company: z.string().optional().nullable(),
    jobTitle: z.string().optional().nullable(),
    
    // Communication Channels
    channels: z.array(ChannelSchema).default([]).describe("A list of all communication channels for this contact."),
    
    // Ownership & Visibility
    createdBy: z.string().describe("The userId of the user who created this contact."),
    visibility: z.enum(["public", "private"]).default("private")
        .describe("'public' is visible to all users in the subscription, 'private' is visible only to the creator."),
    
    // Metadata
    tags: z.array(z.string()).optional().default([]),
    notes: z.string().optional().nullable(),
    timezone: z.string().optional().nullable(),
    
    // Timestamps
    createdAt: z.coerce.date().optional(),
    updatedAt: z.coerce.date().optional(),
});

export default OmniContactSchema;
export { ChannelSchema };